import * as React from 'react';

import * as styles from './styles.css';

interface IProps {
  villageLogoUrl: string | null;
}

export const _VillageImg: React.FC<IProps> = ({ villageLogoUrl }: IProps) => {
  return (
    <div
      className={styles['img']}
      style={{
        backgroundImage: `url("${villageLogoUrl}")`,
        width: '40px',
        height: '40px',
      }}
    />
  );
};

export const VillageImg = React.memo(_VillageImg);
